<template>
  <div class="row align-items-center border-bottom border-bottom-1 border-gray-200 py-10">
    <Select2
        container-class="form-group col-12 col-md-5 mb-7"
        :multiple="false"
        :show-search="true"
        :selectClass="'form-select form-control-sm form-select-solid'"
        :name="`payslip-other-`+id"
        :label="$t('payslip.label.title')"
        labelClass="form-label fs-6 text-black"
        :placeholder-text="$t('payslip.label.title')"
        :parent-id="parentId && '#'+parentId"
        v-model="otherData.id"
        :IsInputGroup="$can(abilities.CREATE_OTHER)"
        icon="bi bi-plus"
        :clickAddon="openOtherModal">
      <option v-for="other in others" :value="other.id" :key="other.id">
        {{ other.title }}
      </option>
    </Select2>

    <InputAmount
        containerClass="col-12 col-md-5 mb-7"
        :label="$t('payslip.label.amount')"
        labelClass="form-label fs-6 text-black"
        :inputClass="'form-control form-control-solid'"
        :number="otherData.value"
        :iso="currency"
        :required="true"
        @keyup="handleEdited"
        @amount="(val) => otherData.value = val"/>

    <div class="col-2">
      <a class="btn btn-sm btn-icon btn-danger p-5" @click.prevent="deleteOtherRow(index)">
        <i class="bi bi-trash-fill fs-5"></i>
      </a>
    </div>
  </div>

  <NewOtherModal :id="'other-create-modal'+id" @reloadDatatable="reloadOther" />
</template>

<script setup>

import Select2 from "@/components/Select2.vue";
import {computed, defineEmits, defineProps, onMounted, ref, watch} from "vue";
import Input from "@/components/Input.vue";
import {useStore} from "vuex";
import NewOtherModal from "@/Modules/RH/views/Setting/others/components/NewOtherModal.vue";
import {calculatePayslipItemValue} from "@/mixins/Helpers";
import abilities from "@/composables/abilities";
import InputAmount from "@/components/InputAmount.vue";


const store = useStore()
const emits = defineEmits(["deleteRow"])
const props = defineProps({
  parentId: String,
  baseSalary: "",
  other: {
    type: Object,
    default: () => ({
      id: '',
      value: 0,
      edited: false
    })
  },
  currency: String,
  index: Number,
  id: String,
})


const otherData = ref(props.other)

const others = computed(() => store.getters['others/getOthers'])
const selectedOtherData = computed(() => {
  if(!otherData.value.id) return null
  return others.value.find(al => al.id === otherData.value.id)
})


watch(() => [props.baseSalary, otherData.value.id], () => {
  handleChange()
}, { deep: true })

const calcSalaryWithOther = (salary, other) => {
  if (!salary) return 0
  if(!other) return 0
  const otherData = other?.data.map?.(al => ({
    range_max: parseFloat(al.range_max),
    range_min: parseFloat(al.range_min),
    type: al.type,
    value: parseFloat(al.value)
  }))
  return calculatePayslipItemValue(parseFloat(props.baseSalary), otherData)
}

const handleChange = () => {
  otherData.value.edited = false
  otherData.value.value = calcSalaryWithOther(props.baseSalary, selectedOtherData.value)
}

const handleEdited = () => {
  otherData.value.edited = true
}

const openOtherModal = () => {
  $('#other-create-modal'+props.id).modal('toggle')
}

function deleteOtherRow(index) {
  emits('deleteRow', index)
}

function reloadOther() {
  store.dispatch('others/loadOthers')
}

onMounted(() => {
  handleChange()
})

</script>

<style scoped>
</style>
